/**
 * @name LoadingDots
 * @description Componente común con la animación de puntos de carga 
 * @author Ricardo Guerra
 */

import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Theme } from '@styles';

const LoadingDots = () => {
  return (
    <Styled.DotsWrapper>
      <Styled.Dot delay="0s" />
      <Styled.Dot delay="0.15s" />
      <Styled.Dot delay="0.30s" />
      <Styled.Dot delay="0.45s" />
    </Styled.DotsWrapper>
  );
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.DotsWrapper = styled.div`
  height: 100%;
  width: 100%;
  margin: auto;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

Styled.LoadingAnimation = keyframes`
   0% {
    opacity: 1;
    transform: scale(0.3);
    background: ${Theme.colors.blueMedium}; 
  }
  25% {
    opacity: 1;
    transform: scale(1.8);
    background: ${Theme.colors.purple};
  }
  50% {
    opacity: 1;
    transform: scale(0.3);
    background: ${Theme.colors.greyDark};
  }
  75% {
    opacity: 1;
    transform: scale(1.8);
    background: ${Theme.colors.red};
  }
  100% {
    opacity: .1;
  }
`;

Styled.Dot = styled.div`
  height: 12px;
  width: 12px;
  border-radius: 50%;
  margin: 12px;
  background: ${(props) => props.theme.colors.greyLight};
  animation: ${Styled.LoadingAnimation} 3s linear infinite;
  animation-delay: ${(props) => props.delay};
`;

export default LoadingDots;